import { UseCustomAxios } from "../../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../../util/Utils";

export function UseFooterCommunications() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validateCommunicate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      type: isEmpty(state.type),
    };

    setter(errorState);

    if (errorState.title || errorState.type) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetFooterCommunications = (FooterId, callback) => {
    MyAxios.get(`Admin_HomePage/GetFooterCommunication/${FooterId}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const SetFooterCommunications = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_HomePage/SetFooterCommunications`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const RemoveFooterCommunications = (Id, callback) => {
    const data = new FormData();
    data.append("Id", Id);
    MyAxios.delete(`Admin_HomePage/RemoveFooterCommunications`, {
      data: data,
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("لینک با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validateCommunicate,
    GetFooterCommunications,
    SetFooterCommunications,
    RemoveFooterCommunications,
  };
}
